// A PERSON'S FIRST NAME FOR A SENTENCE ("Matt took over the texts"). Pure.
//
// ⚠️ THE BUG: "Mr took over the texts". A display name is composed as `[title, first, last]`, so taking its first word gives the HONORIFIC
// for anybody entered with a title and no first name. (The portal greeting hit the same thing and has its own copy of this rule in
// portalGreeting.ts; this one is for the lead screen and the thread, and also knows "Miss".)
//
// Order: an explicit first-name field if there is one; otherwise the first word of the name that is not an honorific; otherwise null, and
// the caller says "Your team". A name that is only an honorific is NO name: "Mr" is worse than none.

const HONORIFICS: ReadonlySet<string> = new Set(['mr', 'mrs', 'ms', 'miss', 'mx', 'dr']);

const isHonorific = (token: string): boolean => HONORIFICS.has(token.replace(/\.$/, '').toLowerCase());

/** The first name, or null when there is none to use. A "[TEST]" marker is dropped first. */
export function personFirstName(name: string | null | undefined, firstName?: string | null): string | null {
  const given = (firstName ?? '').trim();
  if (given !== '' && !isHonorific(given)) return given;
  const tokens = (name ?? '').replace(/^\s*\[TEST\]\s*/i, '').trim().split(/\s+/).filter(Boolean);
  const word = tokens.find((t) => !isHonorific(t));
  return word ?? null;
}

/** For a sentence's subject: the first name, else "Your team". */
export function personFirstNameOrTeam(name: string | null | undefined, firstName?: string | null): string {
  return personFirstName(name, firstName) ?? 'Your team';
}
